module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_long_front_shadow.939a98da.png";